import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { APIServiceProvider } from "../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { NotifyService } from "../../services/notify.service";

@Component({
	selector: "modal-stockreturn",
	templateUrl: "./modal-stockreturn.html"
})
export class StockReturnModalPage {
	public inventory = null;

	public centers: any = [];

	public stockData: any = {
		from_depo: null,
		to_depo: "",
		product_qty: 0,
		product_inventory_items: []
	};
	public user_depo_id: any = localStorage.getItem("user_depo_id");

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		private apiHelper: APIServiceProvider,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		private notifyService: NotifyService
	) {
		this.inventory = this.navParams.get("inventory");

		this.inventory.available_qty = parseInt(this.inventory.available_qty);
		this.inventory.allocated_qty = parseInt(this.inventory.allocated_qty);

		this.stockData.from_depo = this.inventory.depo;

		this.getInvoicingCenters();
		this.getMyInvoicingCenters();
	}

	getMyInvoicingCenters() {
		this.apiHelper
			.get("location/invoice/center/my?depo_id=" + this.user_depo_id)
			.subscribe(
				response => {
					this.stockData.to_depo = parseInt(response["data"]);
				},
				error => {}
			);
	}

	getInvoicingCenters() {
		this.apiHelper.get("location/invoice/center").subscribe(
			response => {
				this.centers = response["data"];
			},
			error => {}
		);
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	submitStockReturn() {
		if (this.stockData.to_depo == "" || this.stockData.to_depo == null) {
			this.helperService.presentToast("Select To Depo");
			return false;
		}

		if (
			this.stockData.product_qty == "" ||
			this.stockData.product_qty == null ||
			parseInt(this.stockData.product_qty) < 1
		) {
			this.helperService.presentToast(
				"Select product quantity for stock return"
			);
			return false;
		}

		let productObj: any = {
			quantity: this.stockData.product_qty,
			available_qty: this.inventory.available_qty,
			product_id: this.inventory.product_id
		};

		this.stockData.product_inventory_items = [];
		this.stockData.product_inventory_items.push(productObj);

		this.apiHelper
			.post("inventory/transactions/save-transfer", this.stockData)
			.subscribe(
				response => {
					if (response["data"]["status"] == "error") {
						this.helperService.presentToast(
							response["data"]["message"]
						);
					} else {
						this.helperService.presentToast(
							response["data"]["message"]
						);
						this.viewCtrl.dismiss();
						this.notifyService.InventoryUpdated();
					}
				},
				error => {
					this.helperService.presentToast(
						"Not abke to submit stock return right now!"
					);

					this.viewCtrl.dismiss();
					this.notifyService.InventoryUpdated();
				}
			);
	}
}



// WEBPACK FOOTER //
// ./src/modals/stockreturn/stockreturn.modal.ts